var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseball(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.84 20.1831C20.3284 20.1831 21.535 19.0247 21.535 17.5959C21.535 16.167 20.3284 15.0087 18.84 15.0087C17.3516 15.0087 16.145 16.167 16.145 17.5959C16.145 19.0247 17.3516 20.1831 18.84 20.1831Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.887 19.0761C1.61387 18.8148 1.21625 18.7132 0.843924 18.8096C0.471595 18.906 0.181122 19.1857 0.0819235 19.5435C-0.0172753 19.9012 0.0898704 20.2826 0.363 20.544L2.65 22.7366C2.92014 23.0088 3.32272 23.1192 3.70185 23.0249C4.08097 22.9306 4.37711 22.6465 4.47558 22.2826C4.57405 21.9187 4.45939 21.5321 4.176 21.2726L1.887 19.0761Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.523 16.2643C5.32775 16.0769 5.01125 16.0769 4.816 16.2643L3.3 17.7187C3.10481 17.9062 3.10481 18.21 3.3 18.3974L4.88 19.9133C5.07525 20.1007 5.39175 20.1007 5.587 19.9133L7.1 18.4608C7.19404 18.3707 7.24689 18.2485 7.24689 18.121C7.24689 17.9934 7.19404 17.8712 7.1 17.7811L5.523 16.2643Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.946 0.966706C22.2509 0.299332 21.2915 -0.0504782 20.3102 0.00567106C19.3289 0.0618203 18.4196 0.518558 17.812 1.26047L6.5 14.5565C6.33759 14.7474 6.35229 15.0255 6.534 15.1997L8.213 16.8096C8.39539 16.9852 8.68708 16.9985 8.886 16.8403L22.664 5.87807C23.427 5.29106 23.8937 4.42009 23.9475 3.48285C24.0014 2.5456 23.6372 1.63066 22.946 0.966706Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseball);
export default __webpack_public_path__ + "static/media/baseball.29aa0d01.svg";
export { ForwardRef as ReactComponent };